import { Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import CardSys from "../cardSys";
import { Box } from "@mui/system";
import ModalSys from "../../components/modal";
import CloseButton from "../generic/closeButton";
import SubTitlePages from "../generic/subTitlePages";
import ListUserByClient from "../listUserByClient";
import ListUserByGroup from "../listUserByGroup";
import ButtonCreate from "../../components/buttonCreate";
import CreateUser from "../../components/createUser";
import { useNavigate } from "react-router-dom";

export default function ClientModules({
  handleClose,
  updateTable,
  id,
  title,
  client,
}) {
  const [modal, setModal] = useState(false)
  const [updateUser, setUpdateTable] = useState(false)
  const [userEdit, setUserEdit] = useState(false)
  const navigate = useNavigate();

  useEffect(() => {

    setUserEdit({ id: id, title: title })

  }, [])

  return (
    <>
      <CardSys marginLeft={"40px"} >
        <Grid container>
          <Grid
            item
            xs={12}
            direction="row"
            marginLeft={"40px"}
            marginTop={"40px"}
            marginBottom={"40px"}
            justifyContent="end"
            alignItems="end"
            sx={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}
          >

            <Grid item sx={{ display: "flex" }}>
              <SubTitlePages sx={{ display: "flex", fontWeight: "bold", color: "4B4B4B" }}>{title}</SubTitlePages>
            </Grid>
            <Grid>
              <ButtonCreate onClick={() => { navigate("/users?create=create"); setModal(true); }} sx={{ color: "white", backGroundColor: "#2C4992", textTransform: "initial" }}>
                Cadastrar novo usuário
              </ButtonCreate>
            </Grid>
            <Grid item sx={{ display: "flex", justifyContent: "end" }}  >
              <CloseButton onClick={handleClose}></CloseButton>
            </Grid>
          </Grid>
          <Grid
            item
            sx={{ display: "flex" }}
            justifyContent="space-between"
            alignItems="center"
            marginTop={"31px"}
            xs={12}
          >

            <Grid container sx={{ display: "flex", justifyContent: "space-between" }} >
              <Grid item xs={6} md={2} sx={{ display: "flex", justifyContent: "center" }}>
                <SubTitlePages sx={{ fontWeight: "bold" }}>
                  Usuários cadastrados
                </SubTitlePages>
              </Grid>
              <Grid item xs={6} md={2.5} sx={{ display: "flex", justifyContent: "end" }}>
                <SubTitlePages sx={{ fontWeight: "bold" }}>
                  Editar
                </SubTitlePages>
              </Grid>
              <Grid item xs={6} md={7} sx={{ display: "flex", justifyContent: "center" }}>
                <SubTitlePages sx={{ fontWeight: "bold" }}>
                  Status
                </SubTitlePages>
              </Grid>
            </Grid>

          </Grid>

        </Grid>
        <Grid
          container
          sx={{ overflowY: "auto", maxHeight: "60vh", marginTop: "16px", marginLeft: "40px", marginBottom: "40px" }}
        >
          {client ? (
            <ListUserByClient id={id}></ListUserByClient>
          ) : (
            <ListUserByGroup id={id}></ListUserByGroup>
          )}
        </Grid>
      </CardSys>
      <ModalSys open={modal} handleClose={() => setModal(false)}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        ></Box>
      </ModalSys>
    </>
  );
}
